<template>
  <b-form-group
    :label="label"
  >
    <v-select
      :name="name"
      :value="optionSelected"
      :options="listOptions"
      :class="{ 'v-select-danger': danger, 'select-size-sm': small }"
      :disabled="isDisabled"
      @input="onInput"
      :placeholder="placeholder"
    >
      <template #spinner>
        <b-spinner
          small
          v-if="documentTypesExternalsState.loading"
          :style="{ opacity: documentTypesExternalsState.loading ? 1 : 0 }"
          variant="primary"
        />
      </template>
      <template slot="no-options">
        no hay tipos de documentos para el criterio de búsqueda
      </template>
    </v-select>
    <div
      v-if="danger"
      class="con-text-validation span-text-validation-danger v-enter-to"
      style="height: 19px;">
      <span class="span-text-validation">
        {{ dangerText }}
      </span>
    </div>
  </b-form-group>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('List', [
      'documentTypesExternalsState'
    ]),
    optionSelected() {
      return this.documentTypesExternalsState.list.find((option) => option.value === this.value);
    },
    isDisabled() {
      return this.disabled
        || !this.documentTypesExternalsState.list.length
        || this.documentTypesExternalsState.loading;
    },
    listOptions() {
      return this.documentTypesExternalsState.list;
    }
  },
  methods: {
    ...mapActions('List', [
      'fetchDocumentTypesExternals'
    ]),
    onInput(event) {
      this.$emit('input', event?.value);
      this.$emit('change', event?.value);
    },
    getOption() {
      return this.documentTypesExternalsState.list.find((option) => option.value === this.value);
    }
  },
  created() {
    this.fetchDocumentTypesExternals(this.companyToLoad);
  },
  props: {
    name: { type: String, required: true },
    label: { type: String, default: 'Tipo Documento' },
    value: { type: String },
    danger: { type: Boolean },
    dangerText: { type: String },
    disabled: { type: Boolean, default: false },
    block: { type: Boolean, default: true },
    small: { type: Boolean, default: false },
    typeNumeration: { type: String },
    companyToLoad: {
      type: String,
      required: false,
      default: null
    },
    placeholder: { type: String }
  }
};

</script>
